import React from "react";
import ReactAudioPlayer from 'react-audio-player';

export default function Audio(props) {
  if (!props.src) {
    return null;
  }

  return (
    props.isMobile ? (
    <div
      style={{ 
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "50px 0px 50px 0px",
            backgroundColor: "black",
             }}>
      <ReactAudioPlayer
        // preload
        controls="controls"
        autoPlay={false}
        src={props.src}
      />
    </div>)
    :(
      <div
      style={{ 
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "50px 0px 50px 0px",
            backgroundColor: "black",
             }}>
      <ReactAudioPlayer
        // preload
        controls="controls"
        autoPlay={false}
        src={props.src}
      />
    </div>)
  );
}
